<template>
  <div ref="print3060">
    <div  style="width: 61mm;height:34.5mm;">
      <div style="padding-left: 3mm;padding-top: 7mm">
        <vue-qr
            :size="1000"
            :margin="0"
            :auto-color="true"
            :dot-scale="1"
            :text="`https://api.86122m.com/h?h=${handle}`"
            class="codeImage"
            style="width: 19mm;height: 19mm;float: left"
        />
      </div>
      <div>
        <div style="font-weight: bold;text-align: center;line-height: 6mm;font-size: 4mm;color: black;">{{ title }}</div>
        <div style="font-size: 3mm;line-height:3mm;text-align: center;">国家标识 专利防伪</div>
        <barcode  :options="barcode_option" :value="handle" style="width: 35mm;margin-left: 1mm" tag="img"></barcode>
        <div style="text-align: center;font-size: 3mm;line-height: 3mm">{{handle}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Barcode from "@xkeshi/vue-barcode";
import VueQr from 'vue-qr'

export default {
  directives: {
    print
  },
  data(){
    return {
      barcode_option: {
        displayValue: false
      },
    }
  },
  components:{Barcode,VueQr},
  props:{
    handle:{
      type:String,
      default: '86.122.2/123'
    },
    title:{
      type:String,
      default: ''
    }
  },
  methods:{

  }
}
</script>

